<rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
  <div class="inputs">
    <div class="field">
      <div class="label">Name</div>
      <div class="input">
        <mat-form-field [floatLabel]="'always'" appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="assistance.name" placeholder="Name" rsValid="cat_name" />
        </mat-form-field>
      </div>
    </div>
    <div class="inputs">
      <div class="field">
        <div class="label">Category</div>
        <div class="input">
          <mat-form-field [floatLabel]="'always'" appearance="fill">
            <mat-label>Category</mat-label>

            <mat-select [(ngModel)]="assistance.category" rsValid="required">
              <mat-select-trigger>
                <mat-icon>{{ (assistance.category | resolveCategory)?.icon }}</mat-icon>&nbsp;&nbsp;{{ (assistance.category | resolveCategory).name }}
              </mat-select-trigger>
              <mat-option [value]="cat.id" *ngFor="let cat of filteredCategories | async" [style.color]="invertColor(cat.color)" [style.background-color]="cat.color">
                <mat-icon>{{cat.icon}}</mat-icon>&nbsp;&nbsp;{{cat.name}}
                <span *ngIf="cat.archived">(Archived)</span>

              </mat-option>
            </mat-select>

          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</rsValidForm>
<br/>
<ng-template #actionButtons>

  <button mat-button (click)="close()">
    Cancel
  </button>

  <button color="primary" mat-button (click)="saveAssistanceType()">
    <mat-icon>save</mat-icon> Save
  </button>

</ng-template>


